export const containsOnlyNumbers = (text: string): boolean => {
  const numbers = /^[0-9]+$/;

  if (text.match(numbers) || text === '') {
    return true;
  }

  return false;
};
